import { getSettings } from './api';

const SESSION_KEY = 'seikoauth_admin_session';

export function isAuthenticated() {
  return !!sessionStorage.getItem(SESSION_KEY);
}

export function getSession() {
  const raw = sessionStorage.getItem(SESSION_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function logout() {
  sessionStorage.removeItem(SESSION_KEY);
}

export async function login(username, password) {
  const { baseUrl } = getSettings();
  const res = await fetch(baseUrl + '/user', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) {
    let msg = 'Identifiants invalides.';
    try {
      const data = await res.json();
      msg = data.error_description || data.error || msg;
    } catch (e) {}
    throw new Error(msg);
  }
  sessionStorage.setItem(SESSION_KEY, JSON.stringify({ username }));
}
